<div class="page-content fade-in-up">
    <div class="row">

        <div class="col-12">

            <div class="ibox">
                <div class="ibox-head">
                    <div class="ibox-title">
                        <h6>Fields Management</h6>
                    </div>
                </div>
                <hr class="hr mt-2 mb-3">
                <div class="ibox-body">
                    <ul class="nav nav-tabs tabs-line">
                        <li class="nav-item">
                            <a *ngIf=" l_term_flag" class="nav-link active" href="#tab-1" data-bs-toggle="tab"
                                (click)="refresh()"><i class="ti-bar-chart"></i>
                                All Fields List</a>
                            <!-- {{mainService.allLableShowObj[mainService.language_cd+'EMB-FIELD2']}} -->
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" *ngIf="create_flag" href="#tab-2" data-bs-toggle="tab"
                                (click)="refresh()"><i class="fa fa-plus-circle" aria-hidden="true"></i> Create
                                Field</a>
                        </li>

                        <li class="nav-item">
                            <a *ngIf="u_term_flag" class="nav-link" href="#tab-3" data-bs-toggle="tab"><i
                                    class="ti-settings"></i>
                                Update Field</a>
                            <!-- {{mainService.allLableShowObj[mainService.language_cd+'EMB-FIELD3']}}</a> -->
                        </li>

                    </ul>
                    <div class="tab-content">
                        <div *ngIf=" l_term_flag">

                            <br>

                            <div class="row">

                                <div class="col-6 text-start">
                                    <mat-form-field style="margin-left: 2%">
                                        <input matInput (keyup)="applyFilter($any($event.target).value)"
                                            placeholder="Filter">
                                    </mat-form-field>
                                </div>
                                <div class="col-6 text-end">
                                    <button class="btn btn-primary" (click)="open_create()">Create</button>

                                </div>

                            </div>


                            <div class=" example-container">
                                <table mat-table [dataSource]="datasource" matSort>
                                    <ng-container matColumnDef="field_id">
                                        <th mat-header-cell *matHeaderCellDef class="text-start" mat-sort-header>
                                            Field ID

                                        </th>
                                        <td mat-cell flex-stretch *matCellDef="let element; let i = index; "
                                            class="text-end">
                                            {{ element.field_id }}</td>
                                    </ng-container>

                                    <ng-container matColumnDef="field_business_name">
                                        <th mat-header-cell *matHeaderCellDef class="text-end" mat-sort-header>
                                            Field Name

                                        </th>
                                        <td mat-cell flex-stretch *matCellDef="let element" class="text-end">
                                            {{ element.field_business_name }} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="field_code">
                                        <th mat-header-cell *matHeaderCellDef class="text-end" mat-sort-header>
                                            Field Code

                                        </th>
                                        <td mat-cell flex-stretch *matCellDef="let element" class="text-end">
                                            {{ element.field_code }} </td>
                                    </ng-container>


                                    <ng-container matColumnDef="action">
                                        <th mat-header-cell *matHeaderCellDef class="text-end" mat-sort-header>
                                            Action
                                        </th>
                                        <td mat-cell flex-stretch *matCellDef="let element" class="text-end">

                                            <button class="btn btn-primary" (click)="open_update(element)"> Update
                                            </button>
                                            <button class="btn btn-danger" (click)="delete(element)">Delete</button>

                                        </td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                                    </tr>
                                </table>
                                <mat-paginator [pageSizeOptions]="[10, 20,50,80,100]"
                                    showFirstLastButtons></mat-paginator>
                            </div>


                        </div>
                        <div *ngIf="create_flag">

                            <br>
                            <div class="row">
                                <div class="col-12 text-end">
                                    <button class="btn btn-primary" (click)="gotolist()">Go To List</button>
                                </div>
                            </div>
                            <br>

                            <div class="row">
                                <div class="col-4 ">
                                    <h6 style="margin: 2%;">
                                        Field Business Name
                                        : <span style="color: red;">*</span>
                                    </h6>
                                </div>
                                <div class="col-4">
                                    <input class="form-control" placeholder="Enter field name"
                                        [(ngModel)]="field['field_business_name']">
                                </div>
                            </div>
                            <br>
                            <div class="row">
                                <div class="col-4 ">
                                    <h6 style="margin: 2%;">
                                        Field Code : <span style="color: red;">*</span></h6>
                                </div>
                                <div class="col-4">
                                    <input class="form-control" placeholder="Enter field code"
                                        [(ngModel)]="field['field_code']">
                                </div>
                            </div>
                            <br>
                            <div class="row">
                                <div class="col-4 ">
                                    <h6 style="margin: 2%;">
                                        Field Technical Name : <span style="color: red;">*</span>
                                    </h6>
                                </div>
                                <div class="col-4">
                                    <input class="form-control" placeholder="Enter field technical name"
                                        [(ngModel)]="field['field_technical_name']">
                                </div>
                            </div>
                            <br>
                            <div class="row">
                                <div class="col-12 text-center">
                                    <button class="btn btn-primary" (click)="create()"> Submit </button>
                                </div>
                            </div>
                        </div>

                        <div *ngIf=" u_term_flag">

                            <br>
                            <div class="text-end">
                                <button class=" btn btn-primary" (click)="gotolist()">Fields List</button>
                            </div>
                            <div class="row">
                                <div class="col-4 ">
                                    <h6 style="margin: 2%;">
                                        Field Name :<span style="color: red;">*</span>
                                    </h6>
                                </div>
                                <div class="col-4">
                                    <input type="text" class="form-control" placeholder="Enter field name"
                                        [(ngModel)]="field['field_business_name']">
                                </div>
                            </div>
                            <br>
                            <div class="row">
                                <div class="col-12 text-center">
                                    <button class="btn btn-primary" (click)="update()">
                                        Update
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>

    </div>
</div>
<ngx-spinner>Loading....</ngx-spinner>